import { store as dashboard } from './dashboard';
import { store as questionnaire } from './questionnaire';

export default {
  dashboard,
  questionnaire
};
